import { store } from "@redux/store"
import * as types from "../types/groupedFoodIdsBasedOnCategory"

export const addFoodsToCategoryGroup = (foods) => ({
  type: types.ADD_FOODS_TO_CATEGORY_GROUP,
  foods
})

export const addFoodToCategoryGroup = (food) => ({
  type: types.ADD_FOOD_TO_CATEGORY_GROUP,
  food
})

export const updateFoodsInCategoryGroup = (updatedFoods) => {
  const oldFoodsMap = {}

  updatedFoods.forEach(updatedFood => {
    oldFoodsMap[updatedFood._id] =
      store.getState().foods?.[updatedFood._id]
  })

  return {
    type: types.UPDATE_FOODS_IN_CATEGORY_GROUP,
    updatedFoods,
    oldFoodsMap
  }
}

export const removeFoodsFromCategoryGroup = (removedFoods) => ({
  type: types.REMOVE_FOODS_FROM_CATEGORY_GROUP,
  removedFoods
})

export const replaceFoodIdsInCategoryGroup = (categoryId, foodIds) => ({
  type: types.REPLACE_FOOD_IDS_IN_CATEGORY_GROUP,
  categoryId,
  foodIds
})


export const addFoodCategoryGroup = (category) => ({
  type: types.ADD_FOOD_CATEGORY_GROUP,
  category
})

export const updateFoodCategoryGroup = (oldCategoryName, newCategoryName) => ({
  type: types.UPDATE_FOOD_CATEGORY_GROUP,
  oldCategoryName,
  newCategoryName
})

export const deleteFoodCategoryGroup = (categoryId) => ({
  type: types.DELETE_FOOD_CATEGORY_GROUPED,
  categoryId
})


export const clearFoodCategoriesGroups = () => ({
  type: types.CLEAR_FOOD_CATEGORIES_GROUPS
})